module.exports = __webpack_public_path__ + "img/panzi.ba51f176.png";